import React, { useState } from "react";
import "./ribbon.css";
import { Link } from "react-router-dom";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Item from "antd/es/list/Item";
import { Tooltip as ReactTooltip } from "react-tooltip";



interface RibbonProps {
  className?: string;
  disableViewDetails?: boolean;
  items?: {
    label?: string;
    icon?: React.ReactNode;
    disableIcon?: React.ReactNode;
    ToggleButton?: React.ReactNode;
    itemClass?: string;
    checkbox?: React.ReactNode;
    checked?: boolean;
    onChange?: () => void;
    showDropdown?: React.ReactNode;
    handleDropdownToggle?: React.ReactNode;
    DropdownButton?: React.ReactNode;
    onClick?: () => void;
    disableButton?: boolean;
    hidden?: boolean;
    tooltipLabel?: string;
  }[];
  ribbonHeading?: string;
  buttonText?: any;
  buttonClass?: string;
  onClickbtn?: () => void;
  onClickbtn2?: () => void;
  toggleData?: string;
  buttonPath?: any
  buttonPath2?: any
  buttonText2?: any;
  hiddenbtn?: boolean;
  hiddenbtn1?: boolean;
  Icon?: any;
  disabled?: any
  disabledBtn2?:any
  columnClass1?: string;
  columnClass2?: string;

}
interface ToggleButtonProps {
  id?: string;
  checked?: any;
  onClick?: () => void;
  onChange?: (arg0: any) => void;
  disableButton?: boolean;

}
export const ToggleButton: React.FC<ToggleButtonProps> = ({
  id,
  checked,
  onClick,
  onChange,
  disableButton

}) => {
  return (
    <div className={`status-toggle ${disableButton ? 'not-allowed' : ''}`}>
      <input
        type="checkbox"
        id={id || "toggle"}
        className="check"
        checked={checked}
        onClick={onClick}
        onChange={onChange}
        disabled={disableButton}
      />
      <label htmlFor={id || "toggle"} className="checktoggle" />
    </div>
  );
};
interface CheckboxProps {
  checked?: boolean;
  onChange?: () => void;
}
export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange }) => {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="form-check-input"
    // style={{ marginRight: '0.5rem' }} // Optional: add some spacing
    />
  );
};

const Ribbon: React.FC<RibbonProps> = ({
  className,
  buttonText,
  onClickbtn,
  onClickbtn2,
  buttonClass,
  items,
  buttonText2,
  hiddenbtn,
  hiddenbtn1,
  Icon,
  disabled,
  columnClass1,
  columnClass2,
  ribbonHeading,
  disabledBtn2,

}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };
  const handleItemClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  // const handleToggleButton = (e: React.MouseEvent) => {
  //   handleDropdownToggle(); // Toggle the dropdown
  //   e.stopPropagation(); // Prevent the click event from bubbling up
  // };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-css">
            <div className="card-body card-body p-2 ">
              <div className="row justify-content-between align-items-center">
                <div className={`${columnClass1 ? { columnClass1 } : 'col-12 col-md-8'} `}>
                  <div className="ribbon">
                    <div className="d-flex gap-2 gap-lg-2 justify-content-between align-items-center justify-content-md-start">
                      {items?.map((item, index) => (
                        <React.Fragment key={index}>
                          {item.icon && !item.disableButton && !item.hidden && (
                            <div
                              className="mb-0 d-flex align-items-center"
                              onClick={item.onClick}
                              style={{ cursor: "pointer" }}
                            >
                              <div data-tooltip-id={`${item?.tooltipLabel}-tooltip`}
                                data-tooltip-content={item?.tooltipLabel}>{item.icon}</div>
                              <ReactTooltip
                                id={`${item?.tooltipLabel}-tooltip`}
                                place="top"
                                content={item?.tooltipLabel}
                                style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: '1000' }}
                              />
                              {item.label ?
                                <p className="ms-1">{item.label}</p>
                                : (<>
                                </>)}
                            </div>
                          )}
                          {item.checkbox && (
                            <div className="mb-0  d-flex align-items-center">
                              <Checkbox
                                checked={item.checked}
                                onChange={item.onChange}
                              />
                              <p className="ms-1">{item.label}</p>
                            </div>
                          )}
                          {item.ToggleButton && (
                            <div className="mb-0  d-flex align-items-center">
                              {item.ToggleButton}
                              <p className="ms-1">{item.label}</p>
                            </div>
                          )}
                          {item.DropdownButton && (
                            <div className="mb-0  d-flex align-items-center">
                              {item.DropdownButton}
                              {/* <p className="ms-1">{item.label}{item.icon}</p> */}
                            </div>
                          )}
                          {item.disableButton && !item.hidden && (
                            <div className="mb-0  d-flex align-items-center">
                              <div
                                className="mb-0  d-flex align-items-center"
                                style={{ cursor: "not-allowed" }}
                              >
                                <span>{item.disableIcon}</span>
                                <p className="ms-1">{item.label}</p>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                       {ribbonHeading && (
                        <h4 className="color-red">{ribbonHeading}</h4>
                      )
                      }
                    </div>
                  </div>
                  <div className=" dropdown-ribbon">
                    <div className="col-12">
                      {items ? (
                        <DropdownButton
                          className="actions-btn text-dark"
                          show={showDropdown}
                          onClick={handleDropdownToggle}
                          title={<>{svgIcons.ActionsIcon} Actions</>}
                        >
                          {items?.map((item, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={handleItemClick}
                              style={{ width: "max-content" }}
                            >
                              {item.icon && !item.disableButton && !item.hidden && (
                                <div
                                  className="mb-0  d-flex align-items-center"
                                  onClick={item.onClick}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span>{item.icon}</span>
                                  <p className="ms-1">{item.label}</p>
                                </div>
                              )}
                              {item.checkbox && (
                                <div className="mb-0  d-flex align-items-center">
                                  <Checkbox
                                    checked={item.checked}
                                    onChange={item.onChange}
                                  />
                                  <p className="ms-1">{item.label}</p>
                                </div>
                              )}
                              {item.ToggleButton && (
                                <div
                                  className="mb-0  d-flex align-items-center"
                                  onClick={(e: any) => e.stopPropagation()}
                                >
                                  {item.ToggleButton}
                                  <p className="ms-1">{item.label}</p>
                                </div>
                              )}
                              {item.DropdownButton && (
                                <div className="mb-0  d-flex align-items-center">
                                  {item.DropdownButton}
                                  {/* <p className="ms-1">{item.label}{item.icon}</p> */}
                                </div>
                              )}
                              {item.disableButton && (
                                <div className="mb-0  d-flex align-items-center">
                                  <div
                                    className="mb-0  d-flex align-items-center"
                                    style={{ cursor: "not-allowed" }}
                                  >
                                    <span className="text-muted">{item.disableIcon}</span>
                                    <p className="ms-1">{item.label}</p>
                                  </div>
                                </div>
                              )}
                            </Dropdown.Item>
                          ))}
                        </DropdownButton>
                      ) :
                        (<>
                        </>)}
                    </div>
                  </div>
                </div>
                <div className={`${columnClass2 ? { columnClass2 } : 'col-12 col-md-4 mt-md-0'} `}>

                  <div className="d-flex gap-2 justify-content-end">
                    {!hiddenbtn1 &&
                      buttonText2 && (
                        <button
                          className={'btn btnribbon2 px-3 '}
                          onClick={onClickbtn2}
                           type="submit"
                           disabled={disabledBtn2}
                        >
                          {Icon} {buttonText2}
                        </button>
                      )}
                    {!hiddenbtn &&
                      buttonText && (
                        <button
                          className={`btn ${buttonClass}`}
                          onClick={onClickbtn}
                          disabled={disabled}
                          type="submit"
                        >
                          {buttonText}
                        </button>
                      )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ribbon;
